import axiosClient from '@aspida/axios';
import api from '~/apis/AutogenTimeeApiClient/admin/$api';
import { configuredAxiosClient } from './configuredAxiosClient';

export const aspidaClient = api(axiosClient(configuredAxiosClient()));
